import React from 'react'
import { Typography } from '@material-ui/core'
import { CampaignType } from '../../../../constants/marketingCampaign'
import { CampaignDefinition } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { Menu } from '../../MarketingCampaigns.promo.services'
import { getOffersFromConfig, getProductDetailsFromConfig } from '../../../../utils/product'
import { normalizeShopIds } from '../../CampaignModalSkeleton/CampaignModalSkeleton.helpers'
import { BogoSameRuleState } from './types'
import { validateBogoSameRule } from './validate'
import { buildBogoSameFormValues } from './buildFormValues'
import { BogoSameRuleStep } from './RuleStep.view'
import { BogoSameConfirmationSummary } from './ConfirmationSummary.view'

const ruleDescription = (
	<Typography variant="body2" style={{ color: '#616161', marginBottom: 14, lineHeight: 1.65 }}>
		Pour chaque offre, le client achète un <strong style={{ color: '#212121' }}>produit</strong> et reçoit
		le <strong style={{ color: '#212121' }}>même produit offert</strong>. Ajoutez les offres une par une.
	</Typography>
)

function getInitialRuleFromCampaign(campaign: any, menus: Menu): BogoSameRuleState {
	const ids = normalizeShopIds(campaign.shopIds)
	const sid = ids[0]
	const offers =
		sid && campaign.config?.products
			? getOffersFromConfig(menus, campaign.config.products, sid)
			: []
	const choosed =
		sid && campaign.config?.products
			? getProductDetailsFromConfig(menus, campaign.config.products, sid, true)
			: []
	return {
		products: campaign.config?.products || [],
		purchasedProducts: choosed,
		selectedProducts: offers,
		disabledPurshasedProducts: [],
		offeredProducts: [],
	}
}

export const buyOneGetOneProductDefinition: CampaignDefinition<BogoSameRuleState> = {
	type: CampaignType.BUY_ONE_GET_ONE_PRODUCT,
	RuleStep: BogoSameRuleStep,
	ConfirmationSummary: BogoSameConfirmationSummary,
	defaultRule: {
		products: [],
		purchasedProducts: [],
		selectedProducts: [],
		disabledPurshasedProducts: [],
		offeredProducts: [],
	},
	validateRule: validateBogoSameRule,
	buildFormValues: buildBogoSameFormValues,
	ruleDescription,
	getInitialRuleFromCampaign,
	confirmationLimitPolicy: 'optional',
	showOrderTypesInConfirmation: true,
	forceDeliveryOrderType: false,
	allowsPermanent: true,
}
